import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { zIndex } from "../../../design-system/tokens/shadows";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { Item, ItemIcon, List, Menu, Search, SearchInput } from "../ChartStudioSelectMenu/ChartStudioSelectMenu.styles";

export { ItemIcon, List, Search, SearchInput };

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.popover};
`;

/** The shared dropdown surface, fixed near its anchor; `$maxHeight` is the room it has, in px. */
export const Surface = styled(Menu).attrs({ tabIndex: -1 })<{
  $left: number;
  $top?: number;
  $bottom?: number;
  $maxHeight: number;
}>`
  position: fixed;
  ${popoverMotion()}
  left: ${({ $left }) => `${$left / 16}rem`};
  top: ${({ $top }) => ($top === undefined ? "auto" : `${$top / 16}rem`)};
  bottom: ${({ $bottom }) => ($bottom === undefined ? "auto" : `${$bottom / 16}rem`)};
  z-index: ${zIndex.popover};
  width: 16rem;
  max-height: ${({ $maxHeight }) => `min(70vh, ${$maxHeight / 16}rem)`};
  gap: ${spacing[1]};
  outline: 0;
`;

export const GroupTitle = styled.div`
  padding: ${spacing[2]} ${spacing[3]} ${spacing[1]};
  color: ${rawColors.text.lowEmphasis};
  ${typographyMixin("caption", 4)}
`;

export const Option = styled(Item)<{ $active: boolean }>`
  background: ${({ $active }) => ($active ? rawColors.structural.themeLight : "transparent")};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const OptionLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OptionHint = styled.span`
  margin-left: auto;
  color: ${rawColors.text.lowEmphasis};
  ${typographyMixin("caption", 4)}
`;

export const Empty = styled.div`
  padding: ${spacing[3]};
  color: ${rawColors.text.lowEmphasis};
  ${typographyMixin("caption", 4)}
`;
